import '@/Polyfills';

import Resources from '@/Resources.js';
import VeeValidate from '@Lib/vee-validate';
import { registerServiceWorker } from '@/Utils/ServiceWorkerRegistration.js';
import { initFirebase } from '@/Firebase.js';
import { setAppPlatformCookie } from '@/Utils/PwaUtility';
import Formatter from '@/Utils/Formatter';
import notify from '@/Plugins/Notify.js';
import breakpoints from '@/Plugins/Breakpoints';
import displayModes from '@/Plugins/DisplayModes';
import ToastWrapper from '@/Components/ToastWrapper.vue';
import Localize from '@/Components/Utils/Localize.js';
import helpUrls from '@Data/HelpUrls.js';
import Stores from '@/Stores';
import { isLazyLoadError } from '@/Utils/LazyLoadUtility';

const configuredApps = new WeakSet();

registerServiceWorker();
initFirebase();
setAppPlatformCookie();

// Prevent PWA prompt
window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
});

export const configureFrameworkApp = (app, router) => {
    if (configuredApps.has(app)) {
        return;
    }

    configuredApps.add(app);

    app.config.errorHandler = (error, instance, info) => {
        const vueComponent = instance?.$options?.name
            || instance?.$options?.__name
            || instance?.$?.type?.name
            || 'unknown';

        if (isLazyLoadError(error)) {
            // eslint-disable-next-line no-console
            console.warn(error);
            return;
        }

        if (typeof window.Rollbar !== 'undefined') {
            window.Rollbar.error(error, { vueComponent, vueInfo: info });
        }
        // eslint-disable-next-line no-console
        console.error(error);
    };

    const g = app.config.globalProperties;
    g.Resources = Resources;
    g.$helpUrls = helpUrls;
    g.$format = Formatter.format;

    app.component('localize', Localize);

    app.use(VeeValidate);
    app.use(breakpoints);
    app.use(displayModes);
    app.use(notify, { extensionName: '$notify', components: [ToastWrapper] });
    app.use(Stores);

    if (router) {
        app.use(router);
    }
};
